"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveDataApi = SaveDataApi;
exports.designListApi = designListApi;
exports.getDataApi = getDataApi;
exports.getTheme = getTheme;
exports.goodDesignList = goodDesignList;
exports.groupDataList = groupDataList;
exports.groupDelete = groupDelete;
exports.groupEdit = groupEdit;
exports.groupInfo = groupInfo;
exports.groupList = groupList;
exports.groupSave = groupSave;
exports.themeSave = themeSave;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function groupDelete(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/delete',
    method: 'GET',
    params: data
  });
}
function groupInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/info',
    method: 'GET',
    params: data
  });
}
function groupList(pram) {
  var data = {
    keywords: pram.keywords,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/group/list',
    method: 'GET',
    params: data
  });
}
function groupDataList(pram) {
  var data = {
    gid: pram.gid,
    keywords: pram.keywords,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/group/data/list',
    method: 'GET',
    params: data
  });
}
function groupSave(pram) {
  var data = {
    formId: pram.formId,
    info: pram.info,
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/system/group/save',
    method: 'POST',
    params: data
  });
}
function groupEdit(pram) {
  var data = {
    formId: pram.formId,
    info: pram.info,
    name: pram.name,
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/group/update',
    method: 'POST',
    params: data
  });
}

/**
 * @description 页面设计 获取数据
 */
function designListApi(params) {
  return (0, _request.default)({
    url: '/admin/page/layout/index',
    method: 'GET',
    params: params
  });
}

/**
 * @description 页面设计商品Tab 获取数据
 */
function goodDesignList(pram) {
  var data = {
    gid: pram.gid
  };
  return (0, _request.default)({
    url: '/admin/system/group/data/list',
    method: 'GET',
    params: data
  });
}

/**
 * @description 页面设计 保存
 */
function SaveDataApi(data, url) {
  return (0, _request.default)({
    url: url,
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取配置
 */
function getDataApi(data) {
  return (0, _request.default)({
    url: '/admin/page/layout/category/config',
    method: 'GET',
    data: data
  });
}

/**
 * @description 保存设置
 */
function themeSave(params) {
  return (0, _request.default)({
    url: "/admin/system/config/saveuniq",
    method: 'post',
    params: params
  });
}

/**
 * @description 获取设置
 */
function getTheme(params) {
  return (0, _request.default)({
    url: "/admin/system/config/getuniq",
    method: 'get',
    params: params
  });
}